import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import LocationServices from '../../../services/LocationServices'; // Make sure the import path is correct
import Swal from "sweetalert2";

const LocationEditModal = ({ show, handleClose, item, test }) => {
  const [selectedState, setSelectedState] = useState('');
  const [formValues, setFormValues] = useState({
    name: '',
    location: '',
    address: {
      street: '',
      city: '',
      state: '',
      pincode: '',
      country: 'India'
    }
  });


  // Populate the form with the item data when the modal opens
  useEffect(() => {
    if (item) {
      setFormValues({
        name: item.name || '',
        location: item.location || '',
        address: {
          street: item?.address?.street || '',
          city: item?.address?.city || '',
          state: item?.address?.state || '',
          pincode: item?.address?.pincode || '',
          country: item?.address?.country || 'India'
        }
      });

      // Set selectedState so city dropdown populates correctly
      setSelectedState(item?.address?.state || '');
    }
  }, [item]);



  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle nested fields like address.street
    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');
      setFormValues((prev) => ({
        ...prev,
        [parentKey]: {
          ...prev[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Also set selectedState for city dropdown
    if (name === 'address.state') {
      setSelectedState(value);
    }
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await LocationServices.updateStore(item._id, formValues);
      console.log(response); // Log the response for debugging
      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Good job!",
          text: "Details have been successfully updated!",
        });
        test((prev) => prev + 1);
        handleClose(); // Close the modal after success
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response.message || "An error occurred while updating.",
        });
      }
    } catch (error) {
      console.error('Failed to update location details', error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update location details.",
      });
    }
  };

  const stateCityData = {
    "Andhra Pradesh": [
      "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati", "Kakinada",
      "Rajahmundry", "Kadapa", "Anantapur", "Kurnool", "Eluru", "Ongole", "Chittoor",
      "Vizianagaram", "Srikakulam", "Machilipatnam", "Tenali", "Bhimavaram", "Adoni",
      "Madanapalle", "Nandyal", "Proddatur", "Hindupur", "Tadepalligudem",
      "Gudivada", "Dharmavaram", "Guntakal", "Narasaraopet", "Tadipatri", "Kavali"
    ],
    "Arunachal Pradesh": [
      "Itanagar", "Naharlagun", "Pasighat", "Aalo", "Seppa", "Tezu", "Daporijo", "Namsai",
      "Ziro", "Roing", "Tawang", "Khonsa", "Bomdila", "Deomali", "Changlang", "Miao",
      "Basar", "Dirang", "Anini", "Koloriang", "Rupa", "Boleng", "Hawai", "Jairampur",
      "Yingkiong", "Hayuliang", "Longding", "Pangin", "Likabali", "Miao"
    ],
    "Assam": [
      "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tezpur", "Tinsukia",
      "Bongaigaon", "Diphu", "Dhubri", "North Lakhimpur", "Karimganj", "Sivasagar",
      "Goalpara", "Barpeta", "Golaghat", "Lumding", "Haflong", "Rangia", "Mangaldoi",
      "Lanka", "Hojai", "Barpeta Road", "Kokrajhar", "Hailakandi", "Dhekiajuli", "Dergaon"
    ],
    "Bihar": [
      "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", "Darbhanga", "Bihar Sharif",
      "Arrah", "Begusarai", "Katihar", "Munger", "Chhapra", "Sasaram", "Bettiah",
      "Motihari", "Saharsa", "Hajipur", "Dehri", "Siwan", "Sitamarhi", "Jamalpur",
      "Jehanabad", "Aurangabad (Bihar)", "Buxar", "Kishanganj", "Nawada", "Bagaha", "Danapur"
    ],
    "Chhattisgarh": [
      "Raipur", "Bhilai", "Durg", "Bilaspur", "Korba", "Rajnandgaon", "Raigarh",
      "Jagdalpur", "Ambikapur", "Chirmiri", "Dhamtari", "Mahasamund", "Bhatapara",
      "Dalli‑Rajhara", "Kawardha", "Champa", "Dongragarh", "Tilda Neora", "Mungeli",
      "Manendragarh", "Kondagaon", "Gobranawapara", "Bemetara", "Baikunthpur"
    ],
    "Goa": [
      "Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda", "Bicholim", "Curchorem",
      "Sanquelim", "Valpoi", "Quepem", "Canacona", "Sanguem", "Cuncolim", "Pernem", "Mormugao"
    ],
    "Gujarat": [
      "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh",
      "Gandhinagar", "Anand", "Navsari", "Surendranagar", "Morbi", "Gandhidham",
      "Nadiad", "Bharuch", "Patan", "Porbandar", "Mehsana", "Bhuj", "Veraval", "Vapi",
      "Valsad", "Godhra", "Palanpur", "Kalol", "Botad", "Amreli", "Deesa", "Dahod",
      "Ankleshwar", "Jetpur"
    ],
    "Haryana": [
      "Gurugram", "Faridabad", "Ambala", "Panipat", "Yamunanagar", "Karnal", "Hisar",
      "Panchkula", "Rohtak", "Rewari", "Jind", "Sonipat", "Narnaul", "Kaithal",
      "Pehowa", "Kurukshetra", "Bahadurgarh"
    ],
    "Himachal Pradesh": [
      "Shimla", "Mandi", "Solan", "Dharamshala", "Hamirpur", "Bilaspur", "Una",
      "Chamba", "Palampur", "Kangra", "Nadaun"
    ],
    "Jharkhand": [
      "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", "Hazaribagh",
      "Giridih", "Jharia", "Ramgarh", "Phusro", "Chas", "Medininagar"
    ],
    "Karnataka": [
      "Bengaluru", "Mysuru", "Hubli-Dharwad", "Mangaluru", "Belagavi", "Kalaburagi",
      "Davangere", "Ballari", "Shivamogga", "Tumakuru", "Udupi", "Vijayapura",
      "Bidar", "Raichur", "Hassan", "Karwar", "Chitradurga"
    ],
    "Kerala": [
      "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Alappuzha", "Kollam",
      "Palakkad", "Kannur", "Kottayam", "Malappuram", "Pathanamthitta", "Thalassery",
      "Ponnani", "Wayanad", "Attingal", "Pala", "Perinthalmanna"
    ],
    "Madhya Pradesh": [
      "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna",
      "Rewa", "Ratlam", "Chhindwara", "Dhar", "Morena", "Guna", "Neemuch", "Vidisha",
      "Shivpuri", "Sehore", "Burhanpur"
    ],
    "Maharashtra": [
      "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Kalyan-Dombivli", "Vasai-Virar",
      "Aurangabad", "Solapur", "Amravati", "Navi Mumbai", "Kolhapur", "Ulhasnagar",
      "Nanded", "Kharghar", "Panvel", "Akola", "Latur", "Malegaon"
    ],
    "Manipur": [
      "Imphal", "Churachandpur", "Thoubal", "Kakching", "Moirang", "Yairipok",
      "Wangjing", "Lilong", "Nambol", "Sekmai Bazar", "Mayang Imphal", "Kumbi",
      "Wabagai", "Lamsang", "Sugnu"
    ],
    "Meghalaya": [
      "Shillong", "Tura", "Nongpoh", "Jowai", "Baghmara", "Williamnagar",
      "Resubelpara", "Nongstoin", "Mairang", "Mawkyrwat", "Sohra", "Khliehriat"
    ],
    "Mizoram": [
      "Aizawl", "Lunglei", "Saiha", "Champhai", "Serchhip", "Kolasib",
      "Lawngtlai", "Mamit", "Saitual", "Hnahthial", "North Vanlaiphai"
    ],
    "Nagaland": [
      "Dimapur", "Kohima", "Mokokchung", "Tuensang", "Zunheboto", "Wokha",
      "Mon", "Phek", "Chumukedima", "Kiphire", "Peren", "Longleng"
    ],
    "Odisha": [
      "Bhubaneswar", "Cuttack", "Rourkela", "Brahmapur", "Sambalpur", "Puri",
      "Balasore", "Baripada", "Bhadrak", "Angul", "Balangir", "Barbil", "Bargarh",
      "Bhanjanagar", "Bhawanipatna", "Byasanagar", "Chatrapur", "Dhenkanal", "Gunupur",
      "Hinjilicut", "Jagatsinghapur", "Jajpur Road", "Jharsuguda", "Joda", "Kendrapara",
      "Kendujhar", "Koraput", "Malkangiri", "Paradip", "Paralakhemundi", "Phulbani",
      "Rayagada", "Talcher"
    ],
    "Punjab": [
      "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali",
      "Hoshiarpur", "Moga", "Batala", "Pathankot", "Abohar", "Malerkotla",
      "Khanna", "Muktsar", "Barnala", "Firozpur", "Phagwara", "Rajpura", "Mukerian"
    ],
    "Rajasthan": [
      "Jaipur", "Jodhpur", "Kota", "Bikaner", "Ajmer", "Udaipur", "Bhilwara",
      "Alwar", "Sikar", "Pali", "Sri Ganganagar", "Hanumangarh", "Jhunjhunu",
      "Churu", "Tonk", "Bharatpur", "Baran", "Banswara", "Dausa", "Nagaur",
      "Jhalawar", "Sawai Madhopur", "Chittorgarh", "Dholpur", "Karauli"
    ],
    "Sikkim": [
      "Gangtok", "Namchi", "Geyzing", "Mangan", "Singtam", "Rangpo",
      "Jorethang", "Soreng", "Pakyong", "Rhenock", "Yuksom"
    ],
    "Tamil Nadu": [
      "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli",
      "Tiruppur", "Vellore", "Erode", "Thoothukudi", "Dindigul", "Thanjavur",
      "Nagercoil", "Kanchipuram", "Karur", "Ambur", "Cuddalore", "Pudukkottai",
      "Sivakasi", "Nagapattinam", "Pollachi", "Arakkonam", "Namakkal", "Rajapalayam"
    ],
    "Telangana": [
      "Hyderabad", "Warangal", "Karimnagar", "Nizamabad", "Khammam", "Mancherial",
      "Mahbubnagar", "Ramagundam", "Nalgonda", "Adilabad", "Suryapet",
      "Miryalaguda", "Siddipet", "Jagtial", "Bodhan", "Kamareddy", "Zaheerabad"
    ],
    "Tripura": [
      "Agartala", "Udaipur", "Dharmanagar", "Kailasahar", "Belonia", "Khowai",
      "Ambassa", "Panisagar", "Kamalpur", "Sonamura", "Sabroom"
    ],
    "Uttar Pradesh": [
      "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut", "Prayagraj",
      "Bareilly", "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Noida",
      "Firozabad", "Jhansi", "Muzaffarnagar", "Mathura", "Ayodhya", "Shahjahanpur",
      "Rampur", "Etawah", "Sitapur", "Raebareli", "Lakhimpur", "Unnao", "Bulandshahr",
      "Faizabad", "Barabanki", "Fatehpur", "Hapur", "Budaun"
    ],
    "Uttarakhand": [
      "Dehradun", "Haridwar", "Haldwani", "Roorkee", "Rudrapur", "Kashipur",
      "Rishikesh", "Nainital", "Pithoragarh", "Tehri", "Almora", "Kotdwara",
      "Champawat", "Bageshwar", "Pauri", "Mussoorie"
    ],
    "West Bengal": [
      "Kolkata", "Asansol", "Siliguri", "Durgapur", "Howrah", "Bardhaman",
      "Malda", "Kharagpur", "Haldia", "Berhampore", "Jalpaiguri", "Chandannagar",
      "Bongaon", "Cooch Behar", "Serampore", "Raiganj", "Balurghat"
    ],
    "Delhi": [
      "New Delhi", "Delhi Cantonment", "Karol Bagh", "Rohini", "Dwarka",
      "Saket", "Narela", "Shahdara", "Najafgarh", "Patel Nagar", "Laxmi Nagar",
      "Rajouri Garden", "Janakpuri", "Model Town", "Vasant Kunj","South West Delhi"
    ],
    "Jammu and Kashmir": [
      "Srinagar", "Jammu", "Baramulla", "Udhampur", "Anantnag", "Kathua",
      "Sopore", "Pulwama", "Rajouri", "Ganderbal", "Poonch", "Kupwara",
      "Bandipora", "Handwara", "Kulgam", "Budgam"
    ],
    "Ladakh": [
      "Leh", "Kargil", "Diskit", "Nubra", "Padum", "Nyoma"
    ],

  };

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}> {/* Bind form submission */}
        <Modal.Header>
          <Modal.Title><i className="fas fa-edit"></i> Edit Location Details!!!</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Name</label>
                <input
                  type="text"
                  name="name" // Make sure this matches the key in formValues
                  className="form-control form-control-sm"
                  value={formValues.name} // Bind the input value to the state
                  onChange={handleInputChange} // Call the change handler
                />
              </Col>
              <Col md="6">
                <label>Location</label>
                <input
                  type="text"
                  name="location" // Make sure this matches the key in formValues
                  className="form-control form-control-sm"
                  value={formValues.location} // Bind the input value to the state
                  onChange={handleInputChange} // Call the change handler
                />
              </Col>
              <Col md="6">
                <label>Street</label>
                <input
                  type="text"
                  name="address.street"
                  className="form-control form-control-sm"
                  value={formValues.address.street}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6">
                <label>State</label>
                <select
                  name="address.state"
                  className="form-control"
                  value={formValues.address.state}
                  onChange={handleInputChange}
                >
                  <option value="">Select State</option>
                  {Object.keys(stateCityData).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="6">
                <label>City</label>
                <select
                  name="address.city"
                  className="form-control"
                  value={formValues.address.city}
                  onChange={handleInputChange}
                  disabled={!selectedState}
                >
                  <option value="">Select City</option>
                  {selectedState &&
                    stateCityData[selectedState]?.map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                </select>
              </Col>
              <Col md="6">
                <label>Pincode</label>
                <input
                  type="text"
                  name="address.pincode"
                  className="form-control form-control-sm"
                  value={formValues.address.pincode}
                  onChange={handleInputChange}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="6">
                <label>Country</label>
                <select
                  name="address.country"
                  className="form-control"
                  value={formValues.address.country}
                  onChange={handleInputChange}
                >
                  <option value="India">India</option>
                </select>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit"> {/* Change to type submit */}
            Save changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default LocationEditModal;
